import { SqlQueryLandingComponent } from './sql-query-landing.component';

export const containers: any[] = [SqlQueryLandingComponent];

export * from './sql-query-landing.component';
